import { IDENTIFIER_TYPES } from '../../../../constants/identifierTypes';

export const getIdentifierPlaceholder = (identifierType, partialMatch = false) => {
  // NOTE(vlad|SPD-15655|2026-08-05): When the partial-match toggle is on, all identifier searches are
  // prefix (starts-with), so hint it — a mid-string fragment won't match. Off = exact match, no hint.
  const suffix = partialMatch ? ' (starts with)' : '';
  switch (identifierType) {
    case IDENTIFIER_TYPES.SIMPLR_TICKET:
      return `Enter Simplr ticket #${suffix}`;
    case IDENTIFIER_TYPES.WIDGET_ID:
      return `Enter Widget ID${suffix}`;
    case IDENTIFIER_TYPES.ROOM_ID:
      return `Enter Room ID${suffix}`;
    case IDENTIFIER_TYPES.PLATFORM_TICKET_ID:
      return `Enter Platform ticket ID${suffix}`;
    default:
      return 'Select identifier first';
  }
};

export const clearAllIdentifiers = (actions) => {
  actions.changeSimplrTicketNumberForAllFilter('');
  actions.changeWidgetIdForAllFilter('');
  actions.changeRoomIdForAllFilter('');
  actions.changePlatformTicketIdForAllFilter('');
};

export const applyIdentifierFilter = ({ identifierType, identifierValue, actions }) => {
  const trimmedValue = (identifierValue || '').trim();

  if (!trimmedValue) {
    return;
  }

  switch (identifierType) {
    case IDENTIFIER_TYPES.SIMPLR_TICKET:
      actions.changeSimplrTicketNumberForAllFilter(trimmedValue);
      break;

    case IDENTIFIER_TYPES.WIDGET_ID:
      actions.changeWidgetIdForAllFilter(trimmedValue);
      break;

    case IDENTIFIER_TYPES.ROOM_ID:
      actions.changeRoomIdForAllFilter(trimmedValue);
      break;

    case IDENTIFIER_TYPES.PLATFORM_TICKET_ID:
      actions.changePlatformTicketIdForAllFilter(trimmedValue);
      break;

    default:
      break;
  }
};

export const getIdentifierValue = (identifierType, identifierValues) => {
  switch (identifierType) {
    case IDENTIFIER_TYPES.SIMPLR_TICKET:
      return identifierValues.simplrTicketNumber || '';
    case IDENTIFIER_TYPES.WIDGET_ID:
      return identifierValues.widgetId || '';
    case IDENTIFIER_TYPES.ROOM_ID:
      return identifierValues.roomId || '';
    case IDENTIFIER_TYPES.PLATFORM_TICKET_ID:
      return identifierValues.platformTicketId || '';
    default:
      return '';
  }
};

export const getActiveIdentifierType = (identifierValues) => {
  if (identifierValues.simplrTicketNumber) {
    return IDENTIFIER_TYPES.SIMPLR_TICKET;
  }
  if (identifierValues.widgetId) {
    return IDENTIFIER_TYPES.WIDGET_ID;
  }
  if (identifierValues.roomId) {
    return IDENTIFIER_TYPES.ROOM_ID;
  }
  if (identifierValues.platformTicketId) {
    return IDENTIFIER_TYPES.PLATFORM_TICKET_ID;
  }

  return null;
};
